<div class="chart-title">
    <div id="chart-label" class="chart-text">
        {{label}} 
    </div>
</div>
